/* eslint-disable */
import { createApp } from 'vue'
import { createMemoryHistory, createRouter } from 'vue-router'
import App from './App.vue'
import LoginView from './LoginView.vue'
import AurhErrView from './AurhErrView.vue'
import { KEYUTIL, KJUR } from "jsrsasign"
import MainView from './MainView.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"


// createApp(App).mount('#app')
const prodIssuer = "https://orcid.org";
const prodUrl = "https://orcid.org/oauth/authorize";
const prodKey = { "kty": "RSA", "e": "AQAB", "use": "sig", "kid": "production-orcid-org-7hdmdswarosg3gjujo8agwtazgkp1ojs", "n": "jxTIntA7YvdfnYkLSN4wk__E2zf_wbb0SV_HLHFvh6a9ENVRD1_rHK0EijlBzikb-1rgDQihJETcgBLsMoZVQqGj8fDUUuxnVHsuGav_bf41PA7E_58HXKPrB2C0cON41f7K3o9TStKpVJOSXBrRWURmNQ64qnSSryn1nCxMzXpaw7VUo409ohybbvN6ngxVy4QR2NCC7Fr0QVdtapxD7zdlwx6lEwGemuqs_oG5oDtrRuRgeOHmRps2R6gG5oc-JqVMrVRv6F9h4ja3UgxCDBQjOVT1BFPWmMHnHCsVYLqbbXkZUfvP2sO1dJiYd_zrQhi-FtNth9qrLLv3gkgtwQ" };

const issuer = prodIssuer;
const authUrl = prodUrl;
const clientId = process.env.VUE_APP_CLIENT_ID

// console.log(process.env.VUE_APP_CLIENT_ID)

function checkSig(id_token, key) {
    let pubKey = KEYUTIL.getKey(key);
    return KJUR.jws.JWS.verifyJWT(id_token, pubKey, {
        alg: ['RS256'], iss: [issuer], aud: clientId, gracePeriod: 15 * 60 //15 mins skew allowed
    });
}

function getSignedIdToken(id_token) {
    if (checkSig(id_token, prodKey)) {
        const signedInIdToken = JSON.parse(KJUR.jws.JWS.parse(id_token).payloadPP);
        return signedInIdToken
    } else {
        return null
    }
}

function getSignedIdTokenTest(id_token) {
    let signedInIdToken = {}
    signedInIdToken.given_name = "Burak"
    signedInIdToken.family_name = "Ozyurt"
    signedInIdToken.sub = ""
    return signedInIdToken
}

function getFragmentParameterByName(name, hash_part) {
    let regex = new RegExp("[\\#&]" + name + "=([^&#]*)"),
        results = regex.exec(hash_part);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}


const routes = [
    { path: '/', component: LoginView },
    { path: '/auth_err/:error', name: "auth_error", component: AurhErrView, props: true },
    { path: '/main', component: MainView }
]

const router = createRouter({
    history: createMemoryHistory(),
    routes,
})

router.beforeEach(async (to, from) => {
    //console.log('to:', to)
    //console.log('from:', from)
    // console.log("hash:", window.location.hash)
    if (window.location.hash) {
        const idToken = getFragmentParameterByName('id_token', window.location.hash)
        if (idToken && to.path != '/main') {
            console.log("idToken:" + idToken)
            const signedInIdToken = getSignedIdToken(idToken)
            if (signedInIdToken) {
                localStorage.setItem("signedIdToken", JSON.stringify(signedInIdToken))
                return "/main"   
            } else if (to.name != 'auth_error'){
                return { name: "auth_error", params: { error: "auth_error" } }
            }
        } else {
            const error = getFragmentParameterByName('error', window.location.hash)
            console.log("beforeEach error:" + error)
            if (error && to.name != 'auth_error') {
                return { name: "auth_error", params: { error: error } }
            }
        }
    }
})

const app = createApp(App)
app.use(router)

fetch(process.env.BASE_URL + 'config.json')
    .then((response) => response.json())
    .then((config) => {
        //console.log("cfg:" + config)
        for (const key in config) {
            app.provide(key, config[key])
        }
        app.mount('#app');
    }).catch((error) => {
        console.log(error)
    });

app.config.globalProperties.window = window;
